var exports = {
  "mr": "x31de4314--ee79e5--highlighted",
  "s5": "x31de4314--ee79e5--price-container",
  "id": "x31de4314--ee79e5--discount",
  "of": "x31de4314--ee79e5--strikethrough",
  "yM": "x31de4314--ee79e5--price-wrapper",
  "i4": "x31de4314--ee79e5--main-price",
};

module.exports = exports;
